import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { API } from '../../backend';
import authHeader from '../../services/auth-header';

const SearchableDropdown = ({ setAsset_desc, asset_desc, setItem_master_id,contract_id, }) => {
    // const [options, setOptions] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setAsset_desc(value);
        // getItems(value);
        
        // const matchingOptions = options
        //     .filter(opt => opt.description && opt.description.toLowerCase().includes(value.toLowerCase()))
        //     .map(opt => opt); 

        // setFilteredOptions(matchingOptions);
        // setShowDropdown(matchingOptions.length > 0);
    };

    const handleOptionClick = (option) => {
        setAsset_desc(option.description);
        setItem_master_id(option.id);
        setShowDropdown(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    // const getItems = (value) => {
    //     if (value.length > 0) {
    //         axios.get(`${API}contracts/search/itemmaster/?description=${value}&contract_id=${contract_id}`, {
    //             headers: authHeader()
    //         }).then((res) => {
    //             const optionsList = res.data.map(val => val);
    //             setOptions(optionsList);
    //             console.log('API response:', res.data);
    //         }).catch(error => {
    //             console.error('Error fetching data:', error);
    //         });
    //     } else {
    //         setOptions([]);
    //         setFilteredOptions([]);
    //         setShowDropdown(false);
    //     }
    // };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div style={{ position: 'relative' }} ref={dropdownRef}>
            <input
                type="text"
                value={asset_desc}
                className="form-control"
                onChange={handleInputChange}
                // placeholder="Type to search"
                // onFocus={() => setShowDropdown(filteredOptions.length > 0)}
            />
            
            {/* {showDropdown && (
                <ul style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    border: '1px solid #ccc',
                    backgroundColor: 'white',
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0,
                    maxHeight: '150px',
                    overflowY: 'auto',
                    zIndex: 1000,
                }}>
                    {filteredOptions.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleOptionClick(option)} 
                            style={{
                                padding: '8px',
                                cursor: 'pointer',
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            {option.description}
                        </li>
                    ))}
                </ul>
            )} */}
        </div>
    );
};

export default SearchableDropdown;
